import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import Header from '@spa/shared/components/Header';
import Footer from '@spa/shared/components/Footer';
import { mediaMin, tabletRange } from '@spa/shared/theme';
export var OfferHeader = /*#__PURE__*/styled(Header).withConfig({
  componentId: "sc-qsd4zc-0"
})(["nav{z-index:3;}"]);
export var OfferFooter = /*#__PURE__*/styled(Footer).withConfig({
  componentId: "sc-qsd4zc-1"
})(["", " ", ""], mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n  "])), function (props) {
  return props.theme.space(24);
}), tabletRange.ipad()(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n  "])), function (props) {
  return props.theme.space(26);
}));
export var InfoSection = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-qsd4zc-2"
})(["display:flex;flex-direction:column;gap:", ";width:100%;"], function (props) {
  return props.theme.gap(4, 'column');
});